// Phase 24 M5 — profile + 2FA + devices API wrappers.

import {
  API_VERSION_PREFIX,
  type DeviceListResponse,
  type DeviceUpsertRequest,
  type Device,
  type TotpDisableResponse,
  type TotpElevationStatusResponse,
  type TotpSetupResponse,
  type TotpStatusResponse,
  type TotpVerifyResponse,
} from '@leyrochain/shared';

import { apiClient } from './client';

export async function setup2fa(): Promise<TotpSetupResponse> {
  const { data } = await apiClient.post<TotpSetupResponse>(`${API_VERSION_PREFIX}/auth/2fa/setup`);
  return data;
}

export async function verify2fa(token: string): Promise<TotpVerifyResponse> {
  const { data } = await apiClient.post<TotpVerifyResponse>(
    `${API_VERSION_PREFIX}/auth/2fa/verify`,
    { token },
  );
  return data;
}

export async function disable2fa(token: string): Promise<TotpDisableResponse> {
  const { data } = await apiClient.post<TotpDisableResponse>(
    `${API_VERSION_PREFIX}/auth/2fa/disable`,
    { token },
  );
  return data;
}

export async function elevate2fa(token: string): Promise<TotpElevationStatusResponse> {
  const { data } = await apiClient.post<TotpElevationStatusResponse>(
    `${API_VERSION_PREFIX}/auth/2fa/elevate`,
    { token },
  );
  return data;
}

export async function status2fa(): Promise<TotpStatusResponse> {
  const { data } = await apiClient.get<TotpStatusResponse>(`${API_VERSION_PREFIX}/auth/2fa/status`);
  return data;
}

export async function elevationStatus2fa(): Promise<TotpElevationStatusResponse> {
  const { data } = await apiClient.get<TotpElevationStatusResponse>(
    `${API_VERSION_PREFIX}/auth/2fa/elevation-status`,
  );
  return data;
}

export async function listDevices(): Promise<DeviceListResponse> {
  const { data } = await apiClient.get<DeviceListResponse>(`${API_VERSION_PREFIX}/devices/me`);
  return data;
}

export async function upsertDevice(input: DeviceUpsertRequest): Promise<Device> {
  const { data } = await apiClient.post<Device>(`${API_VERSION_PREFIX}/devices`, input);
  return data;
}

export async function revokeDevice(id: string): Promise<void> {
  await apiClient.delete(`${API_VERSION_PREFIX}/devices/${id}`);
}

export interface ChangePasswordRequest {
  current_password: string;
  new_password: string;
}

export async function changePassword(input: ChangePasswordRequest): Promise<void> {
  await apiClient.put(`${API_VERSION_PREFIX}/auth/me/password`, input);
}
